import React from 'react'
import { QuestionCardProps } from './types'
import styles from './Question.module.css'

export default function QuestionCard({ question, answer }: QuestionCardProps) {
    return (
        <div className={styles.questionBorder}>
            <p className={styles.questionQ}>{question}</p>
            <p className={styles.questionA}>{answer}</p>
        </div>
    )
}
